import {
  clearGetUserById,
  editUser,
  getAllRoles,
  getUserById,
} from "../../../Redux/Users/UsersActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { Link, useNavigate, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import arrowIcon from "../../../Assets/arrowleft.png";
import toastHelper from "../../../Util/toastHelper";
import React, { useEffect, useState } from "react";
import validator from "../../../Util/validator";
import { FaRegEyeSlash } from "react-icons/fa6";
import styles from "./EditUser.module.scss";
import { FaRegEye } from "react-icons/fa6";

function EditUser() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { roles, userByIdLoading, userById, editUserLoading } = useSelector(
    (state: RootState) => state.users,
  );
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [roleId, setRoleId] = useState<string>("");
  const [isActive, setIsActive] = useState<string>("true");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState<{
    firstName: string;
    lastName: string;
    email: string;
    roleId: string;
    isActive: string;
    password: string;
    confirmPassword: string;
  }>({
    firstName: "",
    lastName: "",
    email: "",
    roleId: "",
    isActive: "",
    password: "",
    confirmPassword: "",
  });

  const editUserHandler = () => {
    const { errors: fieldErrors, isValid } = validator([
      {
        key: "firstName",
        type: "text",
        value: firstName,
      },
      {
        key: "lastName",
        type: "text",
        value: lastName,
      },
      {
        key: "email",
        type: "email",
        value: email,
      },
      {
        key: "roleId",
        type: "text",
        value: roleId,
      },
      {
        key: "isActive",
        type: "text",
        value: isActive,
      },
      {
        key: "password",
        type: "password",
        value: password,
      },
      {
        key: "confirmPassword",
        type: "confirmPassword",
        value: confirmPassword,
      },
    ]);
    setErrors({ ...errors, ...fieldErrors });

    if (isValid) {
      if (!editUserLoading) {
        const successHandler = () => {
          toastHelper.success("User updated successfully");
          navigate("/admin/users", {
            replace: true,
          });
        };

        dispatch(
          editUser({
            userId: Number(id),
            firstName,
            lastName,
            emailAddress: email,
            roleId: parseInt(roleId),
            isActive: isActive === "true",
            password: password,
            confirmPassword: confirmPassword,
            successHandler,
          }),
        );
      }
    }
  };

  useEffect(() => {
    dispatch(getAllRoles());
    if (id) {
      dispatch(getUserById(Number(id)));
    }
    return () => {
      dispatch(clearGetUserById());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (userById) {
      setFirstName(userById?.user?.firstName);
      setLastName(userById?.user?.lastName);
      setEmail(userById?.user?.emailAddress);
      setRoleId(userById?.user?.role?.id);
      setIsActive(userById?.user?.isActive ? "true" : "false");
    }
  }, [userById]);

  if (userByIdLoading) {
    return <Loading />;
  }

  return (
    <div className={styles.mainContainer}>
      <Link to="/admin/users" replace className={styles.backButtonContainer}>
        <button className={styles.button}>
          <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
          Back to Users
        </button>
      </Link>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Edit User</h1>
      </div>
      <div className={styles.formContainer}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>First Name</p>
          <input
            type="text"
            className={styles.input}
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <p className={styles.error}>{errors.firstName}</p>
        </div>
        <div className={styles.doubleInputContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Last Name</p>
            <input
              type="text"
              className={styles.input}
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <p className={styles.error}>{errors.lastName}</p>
          </div>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Email</p>
          <input
            type="text"
            className={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <p className={styles.error}>{errors.email}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Password</p>
          <div className={styles.passwordInputContainer}>
            <input
              type={showPassword ? "text" : "password"}
              className={styles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <button
              type="button"
              className={styles.showPasswordButton}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <FaRegEyeSlash className={styles.icon} />
              ) : (
                <FaRegEye className={styles.icon} />
              )}
            </button>
          </div>
          <p className={styles.error}>{errors.password}</p>
        </div>

        <div className={styles.inputContainer}>
          <p className={styles.label}>Confirm Password</p>
          <div className={styles.passwordInputContainer}>
            <input
              type={showConfirmPassword ? "text" : "password"}
              className={styles.input}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="current-password"
            />
            <button
              type="button"
              className={styles.showPasswordButton}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? (
                <FaRegEyeSlash className={styles.icon} />
              ) : (
                <FaRegEye className={styles.icon} />
              )}
            </button>
          </div>
          <p className={styles.error}>{errors.confirmPassword}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Role</p>
          <select
            className={styles.input}
            value={roleId}
            onChange={(e) => setRoleId(e.target.value)}
          >
            {!roleId && <option value="">Select Role</option>}
            {roles?.map((role) => (
              <option key={role.id} value={role.id}>
                {role.roleName}
              </option>
            ))}
          </select>
          <p className={styles.error}>{errors.roleId}</p>
        </div>

        <div className={styles.inputContainer}>
          <p className={styles.label}>Status</p>
          <select
            className={styles.input}
            value={isActive}
            onChange={(e) => setIsActive(e.target.value)}
          >
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
          <p className={styles.error}>{errors.isActive}</p>
        </div>

        {editUserLoading && <Loading />}

        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={editUserHandler}>
            Edit user
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditUser;
